import {connect} from "react-redux";
import {setSheetsVideosModalButton, setShowSheetsAccueil} from "../../actions/SheetsVideosFormations";
import Sheets from "../../components/Home/Pages/PepiteInfos/LesFichesPratiques/Sheets";
import {setShowOfferModal} from "../../actions/modal";

const MapStateToProps = (state) => ({
    firstsSheetsOfArray: state.sheets.firstsSheetsOfArray,
    searchSheetValue: state.sheets.searchSheetValue,
    sheetsList: state.sheets.searchSheet,
    showSheetsList: state.sheetsvideosformations.showSheetsList,
    sheetsVideosModalButton: state.sheetsvideosformations.sheetsVideosModalButton,
    showSheetsAccueil: state.sheetsvideosformations.showSheetsAccueil,
    navItem: state.navLink.navItem
});

const MapDispatchToProps = (dispatch) => ({
    setSheetsVideosModalButton: (bool) => {
        dispatch(setSheetsVideosModalButton(bool));
    },
    setShowSheetsAccueil: (bool) => {
        dispatch(setShowSheetsAccueil(bool));
    },
    setShowOfferModal: (bool) => {
        dispatch(setShowOfferModal(bool));
    },
});

export default connect(MapStateToProps, MapDispatchToProps)(Sheets);